import * as React from "react";

require("./styles.scss");

export class AirMeltTableHeaderUI extends React.PureComponent<{}, {}> {
  render() {
    let tableHeaderClassNames = "table-header";

    let fullRow = (
      <div className={tableHeaderClassNames}>
        <div className="category-col">Category</div>
        <div className="cm-name-col">CM</div>
        <div className="common-name-col smaller-font">Common Name</div>
        <div className="trade-name-col">Trade Name</div>
        <div className="astm-col">ASTM</div>
        <div className="asm-col">AMS</div>
        <div className="uns-col">UNS</div>
        <div className="din-col">DIN</div>
        <div className="wnr-col">W.-Nr.</div>
        <div className="afnor-col">AFNOR</div>
        <div className="elemental-col">C</div>
        <div className="elemental-col">Mn</div>
        <div className="elemental-col">Si</div>
        <div className="elemental-col">Cr</div>
        <div className="elemental-col">Ni</div>
        <div className="elemental-col">Mo</div>
        <div className="elemental-col">P</div>
        <div className="elemental-col">S</div>
        <div className="elemental-col">V</div>
        <div className="elemental-col">W</div>
        <div className="elemental-col">Co</div>
        <div className="elemental-col">Cu</div>
        <div className="elemental-col">Fe</div>
        <div className="physical-col">
          <span>
            T<sub>S</sub> (&#176;F)
          </span>
        </div>
        <div className="physical-col">
          <span>
            T<sub>L</sub> (&#176;F)
          </span>
        </div>
        <div className="other-col">Other</div>
      </div>
    );

    return fullRow;
  }
}
